import { createContext, useContext } from "react";

import { SOTAPFormModel } from "./SOTAPFormModel.ts";

export const SOTAPFormContext = createContext<SOTAPFormModel>(
  {} as SOTAPFormModel
);

export const useSOTAPFormContext = () => useContext(SOTAPFormContext);
